import _extends from "@babel/runtime-corejs2/helpers/extends";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["size", "intent", "hitzone", "active", "disabled", "children", "className"];
import * as React from 'react';
import clsx from 'clsx';
import { SrOnly } from '../Helper';
import { Base } from '../Base';
import { Icon } from './Icon';
var styles = {
  "root": "AddonButton-root_3T2j8",
  "icon": "AddonButton-icon_14mWK",
  "size-m": "AddonButton-size-m_3BqNq",
  "size-s": "AddonButton-size-s_29vPJ",
  "size-xs": "AddonButton-size-xs_3xEyW",
  "size-xxs": "AddonButton-size-xxs_KQ2Dt",
  "hitzone-flow": "AddonButton-hitzone-flow_si9Lm",
  "hitzone-overlay": "AddonButton-hitzone-overlay_1NlSb",
  "active": "AddonButton-active_2W4Uv",
  "disabled": "AddonButton-disabled_2JQGc"
};
function AddonButton(_ref, ref) {
  var _clsx;
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? 'add' : _ref$intent,
    _ref$hitzone = _ref.hitzone,
    hitzone = _ref$hitzone === void 0 ? 'flow' : _ref$hitzone,
    active = _ref.active,
    disabled = _ref.disabled,
    children = _ref.children,
    className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Base, _extends({
    innerRef: ref,
    tagName: "button",
    type: "button",
    disabled: disabled,
    border: "none",
    padding: "none",
    position: "relative",
    backgroundColor: "transparent",
    className: clsx(styles.root, styles["size-".concat(size)], styles["hitzone-".concat(hitzone)], (_clsx = {}, _defineProperty(_clsx, styles.active, active), _defineProperty(_clsx, styles.disabled, disabled), _clsx), className)
  }, extraProps), /*#__PURE__*/React.createElement(Icon, {
    size: size,
    intent: intent,
    className: styles.icon
  }), /*#__PURE__*/React.createElement(SrOnly, null, children));
}
var Export = /*#__PURE__*/React.forwardRef(AddonButton);
Export.displayName = 'AddonButton';
export { Export as AddonButton };